module.exports = __webpack_public_path__ + "img/14.d9b40e41.jpg";